import React, { useEffect, useState } from "react";
import Page from "../../../../component/Page";
import { Link, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import TitlePage from "../../../../component/TitlePage";
import AddButton from "../../../../component/AddButton";
import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Pagination,
  Select,
  Skeleton,
} from "@mui/material";
import InputSearch from "../../../../component/InputSearch";
import dayjs from "dayjs";
import { getBranchList, getMaterialsExpensesList } from "../../services/api";
import "./list.scss";
import ListLayout from "../../../../component/listLayout";
export default function MaterialsExpensesList() {
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  let id = searchParams.get("id") || "";
  let q = searchParams.get("q") || "";
  let b = searchParams.get("b") || "";
  let d = searchParams.get("d") || "";
  let page = searchParams.get("page") || "1";
  const [data, setData] = useState([]);
  const [rowsPerPage] = useState(10);
  const { profile } = useSelector((state) => state.profile);
  const [branchs, setBranchs] = useState([]);
  useEffect(() => {
    const getBranch = async () => {
      const data = await getBranchList();
      setBranchs(data);
    };
    getBranch();
  }, []);
  useEffect(() => {
    const getList = async () => {
      setLoading(true);
      const data = await getMaterialsExpensesList(q, b,d, page, rowsPerPage);
      setData(data);
      setLoading(false);
    };
    getList();
  }, [q, b,d, page, rowsPerPage]);
  const head = [
    "ที่",
    "ศูนย์เมล็ดพันธุ์ข้าวที่จ่าย",
    "หน่วยงานที่จ่าย",
    "ประเภทเอกสาร",
    "วันที่เอกสาร",
    "รายการ",
    "ศูนย์เมล็ดพันธุ์ข้าวที่รับ",
    "หน่วยงานที่รับ",
    "สถานะ",
    "ดำเนินการ",
  ];
  const body = data?.items?.map((x, i) => {
    return {
      id: x?.DocumentNo,
      item1: (data?.meta?.currentPage - 1) * data?.meta?.itemsPerPage + 1 + i,
      item2: x?.BranchName,
      item3: x?.DepartmentName,
      item4: x?.DocumentType,
      item5: dayjs(x?.DocumentDate).format("DD/MM/BBBB"),
      item6: x?.ItemName || "",
      item7: x?.ToBranchName,
      item8: x?.ToDepartmentName,
      item9: x?.Status,
      item10: [
        <Link
          to={`/materials/materials-expenses/${x?.DocumentNo}`}
          onClick={() =>
            setSearchParams({ id: x?.DocumentNo, page: page, q: q, b: b })
          }
        >
          <Button
            variant="contained"
            sx={{
              background: x?.DocumentStatus === "N" ? "red" : "#fbbe66",
              ":hover": {
                background: x?.DocumentStatus === "N" ? "red" : "#eda844",
              },
            }}
          >
            {x?.DocumentStatus === "N" ? "ยกเลิก" : "เรียกดู"}
          </Button>
        </Link>,
      ],
    };
  });
  return (
    <ListLayout
      title={"รายการจ่าย / ยืม / ซ่อม"}
      action={
        <>
          <AddButton link={"/materials/materials-expenses/add"} />
          {profile?.BranchNo?.BranchNo === "00" && (
            <Box className="col-lg-2 col-md-12 ">
              <Box className="backgroundField" sx={{ marginRight: "20px" }}>
                <FormControl variant="standard" fullWidth>
                  <Select
                    value={b || "all"}
                    onChange={(e) =>
                      setSearchParams({ q: q, b: e.target.value })
                    }
                    disableUnderline
                    MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                  >
                    <MenuItem value="all">ศูนย์ทั้งหมด</MenuItem>
                    {branchs?.map((x, i) => (
                      <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Box>
          )}
          <Box className="col-lg-2 col-md-12 ">
            <Box className="backgroundField" sx={{ marginRight: "20px" }}>
              <FormControl variant="standard" fullWidth>
                <Select
                  value={d || "all"}
                  onChange={(e) => setSearchParams({ q: q, b:b, d: e.target.value })}
                  disableUnderline
                  MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                >
                  <MenuItem value="all">ประเภททั้งหมด</MenuItem>
                  <MenuItem value="จ่าย">จ่าย</MenuItem>
                  <MenuItem value="ยืม">ยืม</MenuItem>
                  <MenuItem value="ซ่อม">ซ่อม</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>
          <InputSearch
            value={q}
            onChange={(e) => setSearchParams({ q: e.target.value, b: b })}
            placeholder={"ค้นหา เลขที่เอกสาร"}
          />
        </>
      }
      loading={loading}
      head={head}
      body={body || []}
      pagination={{
        count: data?.meta?.totalPages,
        page: +page,
        event: { q: q, b: b,d:d, id: id },
      }}
      id={id}
      setSearchParams={setSearchParams}
    />
  );
}
